export const CURRENCIES = [
  { value: "pln", title: "PLN", min: 200 },
  //   { value: "usd", title: "USD", min: 50 },
  //   { value: "eur", title: "EUR", min: 50 },
  { value: "uah", title: "UAH", min: 200 },
];
